<div class="container-fluid browsing-results-container">
    <div
        class="filters-container row d-flex flex-column flex-md-row flex-gap px-4 py-2 justify-content-center align-items-md-center justify-content-md-between"
        [ngStyle]="{ 'background-color': colorCode }"
    >
        <div class="d-flex flex-column flex-md-row align-items-md-center flex-wrap text-white my-2">
            <span class="filter-label fw-bold me-6 mb-3 mb-md-0">Filter by:</span>
            <app-filter-by-grade class="me-0 me-md-6 mb-3 mb-md-0"></app-filter-by-grade>
            <app-filter-by-type></app-filter-by-type>
            <app-filter-clear
                class="clear-filter-btn"
                *ngIf="displayClearFilters"
            ></app-filter-clear>
        </div>

        <app-rank-by #rankByComponent class="rank-filter"></app-rank-by>
    </div>
    <div
        *ngIf="(resources$ | async).length"
        class="browsing-group selenium gtmsection-subjects-results"
    >
        <div class="browsing-group-inner px-md-7 pb-5">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-ms-12 col-lg-12">
                    <div
                        class="col-xs-12 mb-6 mt-0 pt-6 d-flex justify-content-between align-items-center"
                        [ngClass]="{
                            'flex-row': !(breakPoints$ | async).isSearchCard,
                            'flex-column': (breakPoints$ | async).isSearchCard,
                        }"
                    >
                        <span class="media-type-count"
                            >{{ activeNode.title }} includes
                            {{ (count$ | async).toLocaleString() }} resources</span
                        >
                        <div [ngClass]="{ 'mt-4': (breakPoints$ | async).isSearchCard }">
                            <button
                                class="btn btn-primary gtm-advanced-search-button advanced-search d-flex flex-row justify-content-center align-items-center"
                                (click)="onAdvancedSearch()"
                            >
                                <span>Advanced Search</span>
                                <app-icon class="icon ms-3" [type]="'External-link'"></app-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="browsing-items row justify-content-center align-items-start">
                <div
                    class="browsing-item col-auto px-md-4 mb-6"
                    *ngFor="let learningObject of resources$ | async; let index = index"
                >
                    <ng-container *ngIf="learningObject.isCollection; else isNotCollection">
                        <app-collection-browse-card
                            *ngIf="!(breakPoints$ | async).isSearchCard"
                            [learningObject]="learningObject"
                            [gtmPrefix]="gtmPrefix"
                            [gtmDataCardNumber]="index + 1"
                            [posterImageDimension]="'260px'"
                        ></app-collection-browse-card>

                        <app-collection-search-card
                            *ngIf="(breakPoints$ | async).isSearchCard"
                            [learningObject]="learningObject"
                            [gtmPrefix]="gtmPrefix"
                            [gtmDataCardNumber]="index + 1"
                        >
                        </app-collection-search-card>
                    </ng-container>

                    <ng-template #isNotCollection>
                        <app-resource-search-card
                            *ngIf="(breakPoints$ | async).isSearchCard"
                            [learningObject]="learningObject"
                            [gtmPrefix]="'gtm-results-browse-card'"
                            [gtmDataCardNumber]="index + 1"
                        ></app-resource-search-card>
                        <app-resource-browse-card
                            *ngIf="!(breakPoints$ | async).isSearchCard"
                            [learningObject]="learningObject"
                            [gtmPrefix]="gtmPrefix"
                            [gtmDataCardNumber]="index + 1"
                        ></app-resource-browse-card>
                    </ng-template>
                </div>
            </div>
            <div class="row browsing-more ps-md-7">
                <div
                    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 d-flex justify-content-between align-items-center"
                    [ngClass]="{
                        'flex-row': !(breakPoints$ | async).isSearchCard,
                        'flex-column': (breakPoints$ | async).isSearchCard,
                    }"
                >
                    <div>
                        <button
                            class="gtm-browse-subjects-see-more btn btn-primary view-more"
                            *ngIf="!!(nextPageURL$ | async)"
                            (click)="loadNextPage()"
                        >
                            + Show more resources
                        </button>
                    </div>
                    <div [ngClass]="{ 'mt-4': (breakPoints$ | async).isSearchCard }">
                        <button
                            class="btn btn-primary gtm-advanced-search-button advanced-search d-flex flex-row justify-content-center align-items-center"
                            (click)="onAdvancedSearch()"
                        >
                            <span>Advanced Search</span>
                            <app-icon class="icon ms-3" [type]="'External-link'"></app-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div
        *ngIf="(resources$ | async)?.length === 0 && (loading$ | async) === false"
        class="no-results"
    >
        <span>Uh oh...</span>
        <div>
            There are no more results for the filters you have selected. You can try broadening your
            filters to see more results again.
        </div>
    </div>
    <div class="loading" *ngIf="loading$ | async">
        <app-preloader></app-preloader>
    </div>
</div>
